module.exports = __webpack_public_path__ + "img/electronic_electric_enabled.863924f0.svg";